import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import { Layout } from "./pages";
import { AuthProvider } from "./hooks/useAuth";
import AuthenticatedApp from "./AuthenticatedApp";

import i18n from "./i18n/i18n";

function App() {
  return (
    <AuthProvider>
      <Router>
        <I18nextProvider i18n={i18n}>
          <Layout>
            <AuthenticatedApp />
          </Layout>
        </I18nextProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
